<template>
    <div id="Tarefas" class="container" v-if="checarVisualizacao()">
        <div class="row">
            <div id="card-info">
                <div class="col s12 m6 l3">
                    <div id="card0" class='border-radius-3 card min-height-100 blue-aqua-light white-text tasks-item estagio card0' :class="mostrarProspeccao() ? 'active': ''">
                            <i class="material-icons white-text">input</i>
                            <p class="no-margin uppercase">Prospecção</p>
                    </div>
                </div>
                <div class="col s12 m6 l3">
                    <div id="card1" class='border-radius-3 card min-height-100 pink darken-2 white-text tasks-item estagio card1' :class="mostrarContato() ? 'active': ''">
                                <i class="material-icons white-text">phone</i>
                                <p class="no-margin uppercase">Chamada Telefônica</p>
                    </div>
                </div>
                <div class="col s12 m6 l3">
                    <div id="card2" class='border-radius-3 card min-height-100 yellow-light white-text tasks-item estagio card2' :class="mostrarVisita() ? 'active': ''">
                                <i class="material-icons white-text">perm_contact_calendar</i>
                                <p class="no-margin uppercase">Visita</p>
                    </div>
                </div>
                <div class="col s12 m6 l3">
                    <div id="cardanalise" class='border-radius-3 card min-height-100 blue darken-4 white-text tasks-item estagio cardanalise' :class="mostrarCold() ? 'active': ''">
                                <i class="material-icons white-text">pause</i>
                                <p class="no-margin uppercase">Análise de Necessidade</p>
                    </div>
                </div>
                <div class="col s12 m6 l3">
                    <div id="carda2visita" class='border-radius-3 card min-height-100 orange-light white-text tasks-item estagio carda2visita' :class="mostrarSegundaVisita() ? 'active': ''">
                                <i class="material-icons white-text">play_circle_filled</i>
                                <p class="no-margin uppercase">2ª Visita</p>
                    </div>
                </div>
                <div class="col s12 m6 l3">
                    <div id="card3" class='border-radius-3 card min-height-100 blue-light lighten-9 white-text tasks-item estagio card3' :class="mostrarNegociacao() ? 'active': ''">
                                <i class="material-icons white-text">business_center</i>
                                <p class="no-margin uppercase">Em negociação</p>
                    </div>
                </div>
                <div class="col s12 m6 l3">
                    <div id="cardanaliseguradora" class='border-radius-3 card min-height-100 red-light white-text tasks-item estagio cardanaliseguradora' :class="mostrarAnaliseSeguradora() ? 'active': ''">
                                <i class="material-icons white-text">settings</i>
                                <p class="no-margin uppercase center">Em Processo de Análise da Seguradora</p>
                    </div>
                </div>
                <div class="col s12 m6 l3">
                    <div id="card4" class='border-radius-3 card min-height-100 white-text tasks-item estagio card4' :class="classEfetivado()">
                                <!-- <i class="material-icons white-text">done</i> -->
                                <i v-if="!checkActions() && checarBotaoNegativar() || successNegativado" class="material-icons white-text">close</i>
                                <i v-if="!checkActions() && checarBotaoEfetivar() || successEfetivado || (!checarBotaoNegativar() && !checarBotaoNegativar())" class="material-icons white-text">done</i>
                                <p v-if="!checkActions() && checarBotaoNegativar() || successNegativado" class="no-margin uppercase">Não Efetivado</p>
                                <p v-if="!checkActions() && checarBotaoEfetivar() || successEfetivado || (!checarBotaoNegativar() && !checarBotaoNegativar())"  class="no-margin uppercase">Efetivado</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col m12">
                <div class="col m12 white">
                    <div class="row gradient-45deg-light-blue-cyan esteira center-align">
                        <div :class="mostrarContato() || checkColdMark([1, 2, 6]) ? 'col m3 s6 estagio active': 'col m3 s6 estagio'">
                            <i class="material-icons background-round mt-5">phone</i>
                            <p>Contato telefônico</p>
                        </div>
                        <div :class="mostrarVisita() || checkColdMark([3]) ? 'col m3 s6 estagio active': 'col m3 s6 estagio'">
                            <i class="material-icons background-round mt-5">perm_contact_calendar</i>
                            <p>Visita</p>
                        </div>
                        <div :class="mostrarAnaliseSeguradora() || checkColdMark([9]) ? 'col m3 s6 estagio active': 'col m3 s6 estagio'">
                            <i class="material-icons background-round mt-5">business_center</i>
                            <p>Em negociação</p>
                        </div>
                        <div :class="mostrarFinalizar() || checkColdMark([4, 5, 8]) ? 'col m3 s6 estagio active': 'col m3 s6 estagio'">
                            <i class="material-icons background-round mt-5">check</i>
                            <p>Processo finalizado</p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>

        <div class="row" v-show="mostrarProspeccao()">
            <div class="col m12">
                <button
                    name="action"
                    type="button"
                    class="btn waves-effect waves-light right mr-2 mb-5"
                    v-on:click="pularProspeccao()"
                    v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])"
                >
                    Avançar etapa
                </button>
            </div>
        </div>

        <div class="row" v-show="mostrarVisita()">
            <div class="col m12">

            </div>
        </div>

        <div class="row">
            <div class="col m12">
                <div class="col m12 white">
                    <div class="mt-5" v-if="mostrarContato()">
                        <div class="">
                            <form>
                                <div class="row">
                                    <div class="col s12 m6 l6">
                                        <label for="pedido_contato_tipo">Tipo</label>
                                        <select class="browser-default" v-model="pedido_contato.pedido_contato_tipo" id="pedido_contato_tipo">
                                            <option value="" disabled selected>Selecione ...</option>
                                            <option value="ligacao">Ligação</option>
                                            <option value="email">Email</option>
                                            <option value="whatsapp">Whatsapp</option>
                                        </select>
                                    </div>

                                    <div class="col s12 m6 l6">
                                        <label for="contato_estado_id">Estado</label>
                                        <select class="browser-default" v-model="pedido_contato.pedido_contato_estado_id" id="contato_estado_id">
                                            <template v-if="pedido_contato.pedido_contato_tipo !== 'ligacao'">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option v-for="s in estadoContatoEmail" :key="s.id" v-bind:value="s.id">{{s.mensagem}}</option>
                                            </template>
                                            <template v-else>
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option v-for="s in estadoContatoTelefonico" :key="s.id" v-bind:value="s.id">{{s.mensagem}}</option>
                                            </template>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="input-field col s12 m6 l6">
                                        <masked-input type="text" id="pedido_contato_data" v-model="pedido_contato.pedido_contato_data" mask="11/11/1111" />
                                        <label for="pedido_contato_data" :class="checkValue(pedido_contato.pedido_contato_data)">Data</label>
                                    </div>
                                    <div class="col s12 m6 l6">
                                        <div class="input-field">
                                            <masked-input type="text" id="pedido_contato_hora" v-model="pedido_contato.pedido_contato_hora" mask="11:11" />
                                            <label for="pedido_contato_hora" :class="checkValue(pedido_contato.pedido_contato_hora)">Hora</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="input-field col s12">
                                        <ObservacoesText v-model="pedido_contato.pedido_contato_observacoes" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col s12">
                                        <button
                                            name="action"
                                            type="button"
                                            class="btn btn-default waves-effect waves-light right mb-5"
                                            v-on:click="salvar"
                                            v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])"
                                        >
                                            Salvar
                                            <!-- <i class="material-icons right">send</i> -->
                                        </button>
                                        <button
                                            name="action"
                                            type="button"
                                            class="btn waves-effect waves-light right mr-2 mb-5"
                                            v-on:click="pularContato()"
                                            v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])"
                                        >
                                            Avançar etapa
                                            <!--<i class="material-icons right">fast_forward</i>-->
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="" v-show="mostrarVisita()">
                        <div class="row">

                        <div class="col s12 m6 l6">
                            <label for="pedido_visita_avulsa_estado_id">Tipo</label>
                            <select class="browser-default" v-model="showContainerVisita" id="showContainerVisita">
                                <option value="" disabled selected>Selecione ...</option>
                                <option value="1">Contato</option>
                                <option value="2">Atividade</option>
                            </select>
                        </div>


                            <!-- <div class="col s6" style="padding: 0;">
                                <ul class="tabs tabs-fixed-width tab-demo z-depth-1" ref="tabVisita">
                                    <li class="tab col s4"><a href="#visitaContato">Contato</a></li>
                                    <li class="tab col s4"><a class="active" href="#visitaAtividade">Atividade</a></li>
                                </ul>
                            </div> -->
                        </div>
                        <br>

                        <div v-show="showContainerVisita == 1" id="visitaContato" class="col s12">
                            <div class="">
                                <form>
                                    <div class="row" v-if="checaCargoUsuario([cargoDono, cargoGerente, cargoEspecialista])">
                                        <div class="col s12 m6 l6">
                                            <label for="pedido_contato_avulso_tipo">Responsável</label>
                                            <select class="browser-default" v-model="pedido_contato_avulso.funcionario_id">
                                                <option value="" disabled selected>Selecione um responsavel</option>
                                                <option
                                                    v-for="responsavel in funcionarios"
                                                    :value="responsavel.funcionario_id"
                                                    :key="responsavel.funcionario_id"
                                                >
                                                    {{ responsavel.pessoa.pessoa_nome }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12 m6 l6">
                                            <label for="pedido_contato_avulso_tipo">Tipo</label>
                                            <select class="browser-default" v-model="pedido_contato_avulso.pedido_contato_avulso_tipo" id="pedido_contato_avulso_tipo">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="ligacao">Ligação</option>
                                                <option value="email">Email</option>
                                                <option value="whatsapp">Whatsapp</option>
                                            </select>
                                        </div>

                                        <div class="col s12 m6 l6">
                                            <label for="pedido_contato_avulso_estado_id">Estado</label>
                                            <select class="browser-default" v-model="pedido_contato_avulso.pedido_contato_avulso_estado_id" id="pedido_contato_avulso_estado_id">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="1">Efetuado e agendado</option>
                                                <option value="2">Não atendeu</option>
                                                <option value="3">Telefone ocupado</option>
                                                <option value="4">Telefone não existe</option>
                                                <option value="5">Telefone desligado</option>
                                                <option value="6">Efetuado com retorno</option>
                                                <option value="7">Não possui mais interesse</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12 m6 l6">
                                            <masked-input type="text" id="pedido_contato_avulso_data" v-model="pedido_contato_avulso.pedido_contato_avulso_data" mask="11/11/1111"/>
                                            <label for="pedido_contato_avulso_data" :class="checkValue(pedido_contato_avulso.pedido_contato_avulso_data)">Data</label>
                                        </div>
                                        <div class="col s12 m6 l6">
                                            <div class="input-field">
                                                <masked-input type="text" id="pedido_contato_avulso_hora" v-model="pedido_contato_avulso.pedido_contato_avulso_hora" mask="11:11" />
                                                <label for="pedido_contato_avulso_hora" :class="checkValue(pedido_contato_avulso.pedido_contato_avulso_hora)">Hora</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <ObservacoesText v-model="pedido_contato_avulso.pedido_contato_avulso_observacoes" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12">
                                            <button class="btn btn-default waves-effect waves-light right mb-5" type="button" name="action" v-on:click="salvarContatoAvulso" v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                <!-- <div class="divider"></div>
                                <div class="row">
                                    <div class="col m12">
                                        <h5 class="title">Contatos feitos</h5>
                                        <ul id="profile-page-about-feed" class="collection z-depth-1">
                                            <li class="collection-item avatar" v-if="estagio.pedido_contato_avulso_estagio === 'C'" v-for="estagio in pedido.pedido_contato_avulsos"> -->
                                          <!--  <li class="collection-item avatar" v-for="estagio in pedido.pedido_contato_avulsos">
                                                <i class="material-icons circle lime darken-4">perm_phone_msg</i>
                                                <span class="title">{{estagio.funcionario.pessoa.pessoa_nome}}</span>
                                                <p>
                                                    {{estagio.funcionario.empresa.empresa_nome_fantasia}} -
                                                    {{estagio.funcionario.funcionario_cargo.funcionario_cargo_nome}}
                                                    <br>
                                                    <span class="ultra-small">
                                                        {{getData(estagio.pedido_contato_avulso_data)}}
                                                    </span>
                                                </p>
                                                <a href="#!" class="secondary-content">
                                                    <i class="material-icons">check</i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div v-show="showContainerVisita == 2" id="visitaAtividade" class="col s12 active">
                            <div class="">
                                <form>
                                    <div class="row">
                                        <div class="col s12 m6 l6">
                                            <label for="pedido_visita_tipo">Tipo</label>
                                            <select class="browser-default" v-model="pedido_visita.pedido_visita_tipo" id="pedido_visita_tipo">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="visita">Visita</option>
                                                <option value="reuniao">Reunião</option>
                                                <option value="atividade">Atividade</option>
                                                <option value="almoco">Almoço</option>
                                            </select>
                                        </div>

                                        <div class="col s12 m6 l6">
                                            <label for="pedido_visita_estado_id">Estado</label>
                                            <select class="browser-default" v-model="pedido_visita.pedido_visita_estado_id" id="pedido_visita_estado_id">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="1">Marcação</option>
                                                <option value="2">Efetuada com sucesso</option>
                                                <option value="3">Remarcada</option>
                                                <option value="4">Não estava presente</option>
                                                <option value="5">Cancelada</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12 m6 l6">
                                            <masked-input type="text" id="pedido_visita_data" v-model="pedido_visita.pedido_visita_data" mask="11/11/1111" />
                                            <label for="pedido_visita_data" :class="checkValue(pedido_visita.pedido_visita_data)">Data</label>
                                        </div>
                                        <div class="col s12 m6 l6">
                                            <div class="input-field">
                                                <masked-input type="text" id="pedido_visita_hora" v-model="pedido_visita.pedido_visita_hora" mask="11:11" />
                                                <label for="pedido_visita_hora" :class="checkValue(pedido_visita.pedido_visita_hora)">Hora</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12">
                                            <label for="pedido_historico_agenda_endereco" class="active">Endereço</label>
                                            <gmap-input
                                                id="pedido_historico_agenda_endereco"
                                                :field-name="'pedido_historico_agenda_endereco'"
                                                :end="pedido_visita.pedido_historico_agenda_endereco"
                                                :latitude="pedido_visita.pedido_historico_agenda_endereco_latitude"
                                                :longitude="pedido_visita.pedido_historico_agenda_endereco_longitude"
                                                @newgmapdata="handleDataGmapVisita($event)">
                                            </gmap-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <ObservacoesText v-model="pedido_visita.pedido_visita_observacoes" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12">
                                            <button class="btn btn-default waves-effect waves-light right mb-5" type="button" name="action" v-on:click="salvarVisita" v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                            <button class="btn right mr-2 mb-5" type="button" name="action" v-on:click="pularVisita()" v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])">
                                                Avançar etapa
                                                <!-- <i class="material-icons right">fast_forward</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-show="mostrarSegundaVisita()">
                        <div class="row">
                            <div class="col s12 m3 offset-2">
                                <div @click="duplicarLead()" style="cursor: pointer; background-color: var(--color-primary);" class="card border-radius-3">
                                    <div class="center">
                                        <h4 class="header2 white-text">Duplicar</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col s12 m3 offset-2">
                                <div @click="pularEmNegociacao()" style="cursor: pointer;" class="card border-radius-3 border-negociacao">
                                    <div class="center">
                                        <h4 class="header2">Em Negociação</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col s12 m3 offset-2">
                                <div @click="pularAnaliseSeguradora()" style="cursor: pointer;" class="card border-radius-3 border-analise-seguradora">
                                    <div class="center">
                                        <h4 class="header2">Análise da Seguradora</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="" v-show="mostrarNegociacao()">
                        <div class="formNegativado">
                                <form>
                                    <div class="row">
                                        <div class="col s12">
                                            <label for="pedido_negativado_motivo">Motivo</label>
                                            <select class="browser-default" v-model="pedido_negativado.pedido_negativado_motivo" id="pedido_negativado_motivo">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="1">Não concorda com custo</option>
                                                <option value="2">Fechou com outra corretora</option>
                                                <option value="3">Fechou com banco</option>
                                                <option value="4">Não gostou dos benefícios</option>
                                                <option value="5">Já tem outra corretora</option>
                                                <option value="6">Não tem interesse</option>
                                                <option value="7">Sem retorno do cliente</option>
                                                <option value="8">Renovou com o corretor da apólice</option>
                                                <option value="9">Desistiu do Seguro</option>
                                                <option value="10">Somente Cotação</option>
                                                <option value="11">Telefone inválido</option>
                                                <option value="12">Não teve aceitação nas Seguradoras</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <ObservacoesText v-model="pedido_negativado.pedido_negativado_observacoes" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        <div class="row">
                            <div class="col s12 m3 offset-2">
                                <div @click="pularNegociacaoParaAnaliseSeguradora()" style="cursor: pointer;" class="card border-radius-3 border-analise-seguradora">
                                    <div class="center">
                                        <h4 class="header2">Análise da Seguradora</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col s12 m3 offset-2">
                                <div @click="salvarNegativado()" style="cursor: pointer;" class="card border-radius-3 border-danger">
                                    <div class="center">
                                        <h4 class="header2">Não Efetivado</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="finalizar" v-if="mostrarFinalizar()">
                        <div class="card-action">
                            <div class="row mt-3" v-if="checkActions()  ||  (successEfetivado || successNegativado)">
                                <div class="col s12 m3 offset-m2 finalizarActions ">
                                    <div @click="efetivar" style="cursor: pointer;" class="card border-radius-3"  :class="classeFinalizarEfetivado">
                                        <div class="center">
                                             <!-- <i class="material-icons background-round mt-5 white-text">check</i> -->
                                            <h4 class="header2"  :class="classeFinalizarEfetivado ? 'white-text' : ''">Efetivado</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col s12 m3 finalizarActions" v-if="checkActions() ||  (successEfetivado || successNegativado)">
                                    <div @click="negativar" style="cursor: pointer;" class="card border-radius-3" :class="classeFinalizarNaoEfetivado">
                                        <div class="center">
                                           <!-- <i class="material-icons background-round mt-5 white-text">close</i> -->
                                            <h4 class="header2" :class="classeFinalizarNaoEfetivado ? 'white-text' : ''">Não efetivado</h4>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <h4 class="header2 text-center green-text" v-if="!checkActions() && checarBotaoEfetivar() || successEfetivado">O lead se encontra efetivado!</h4>
                            <h4 class="header2 text-center red-text" v-if="!checkActions() && checarBotaoNegativar()  || successNegativado">O lead se encontra não efetivado!</h4>

                            <div class="formEfetivado" v-if="checkShowFormEfetivado()">
                                <form>
                                    <div class="row">
                                        <div class="col s12">
                                            <label for="pedido_efetivado_motivo">Motivo</label>
                                            <select class="browser-default" v-model="pedido_efetivado.pedido_efetivado_motivo" id="pedido_efetivado_motivo">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="1">Efetivado com sucesso</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <ObservacoesText v-model="pedido_efetivado.pedido_efetivado_observacoes" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn cyan waves-effect waves-light right"
                                                    v-on:click="salvarEfetivado"
                                                    type="button">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="formNegativado" v-if="checkShowFormNegativado()">
                                <form>
                                    <div class="row">
                                        <div class="col s12">
                                            <label for="pedido_negativado_motivo">Motivo</label>
                                            <select class="browser-default" v-model="pedido_negativado.pedido_negativado_motivo" id="pedido_negativado_motivo">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="1">Não concorda com custo</option>
                                                <option value="2">Fechou com outra corretora</option>
                                                <option value="3">Fechou com banco</option>
                                                <option value="4">Não gostou dos benefícios</option>
                                                <option value="5">Já tem outra corretora</option>
                                                <option value="6">Não tem interesse</option>
                                                <option value="7">Sem retorno do cliente</option>
                                                <option value="8">Renovou com o corretor da apólice</option>
                                                <option value="9">Desistiu do Seguro</option>
                                                <option value="10">Somente Cotação</option>
                                                <option value="11">Telefone inválido</option>
                                                <option value="12">Não teve aceitação nas Seguradoras</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <ObservacoesText v-model="pedido_negativado.pedido_negativado_observacoes" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right"
                                                    v-on:click="salvarNegativado"
                                                    type="button"
                                                    v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="cold" v-if="mostrarCold()">
                        <div class="col m12">
                            <button
                                name="action"
                                type="button"
                                class="btn waves-effect waves-light right mr-2 mb-5"
                                v-on:click="pularAnaliseNecessidade()"
                                v-if="checaCargoUsuario([cargoDono, cargoCorretor, cargoLider])"
                            >
                                Avançar etapa
                            </button>
                        </div>
                    </div>

                    <div class="lost" v-if="mostrarLost()">
                        <div class="row">
                            <div class="col m12" style="background-color: #f9f9f9;">
                                <h4 class="header2">Cliente sinalizado como NÃO EFETIVADO</h4 class="header2">
                                <p>Responsável: {{ pedido.pedido_historico.funcionario.pessoa.pessoa_nome }}</p>
                                <p>Data: {{ getData(pedido.pedido_historico.data_criacao) }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="negociacao" v-show="mostrarAnaliseSeguradora()">
                        <div class="formNegativado">
                                <form>
                                    <div class="row">
                                        <div class="col s12">
                                            <label for="pedido_negativado_motivo">Motivo</label>
                                            <select class="browser-default" v-model="pedido_negativado.pedido_negativado_motivo" id="pedido_negativado_motivo">
                                                <option value="" disabled selected>Selecione ...</option>
                                                <option value="1">Não concorda com custo</option>
                                                <option value="2">Fechou com outra corretora</option>
                                                <option value="3">Fechou com banco</option>
                                                <option value="4">Não gostou dos benefícios</option>
                                                <option value="5">Já tem outra corretora</option>
                                                <option value="6">Não tem interesse</option>
                                                <option value="7">Sem retorno do cliente</option>
                                                <option value="8">Renovou com o corretor da apólice</option>
                                                <option value="9">Desistiu do Seguro</option>
                                                <option value="10">Somente Cotação</option>
                                                <option value="11">Telefone inválido</option>
                                                <option value="12">Não teve aceitação nas Seguradoras</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <ObservacoesText v-model="pedido_negativado.pedido_negativado_observacoes" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        <div class="row">
                            <div class="col s12 m3 offset-2">
                                <div @click="salvarEfetivado()" style="cursor: pointer;" class="card border-radius-3 border-success">
                                    <div class="center">
                                        <h4 class="header2">Efetivar</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col s12 m3 offset-2">
                                <div @click="salvarNegativado()" style="cursor: pointer;" class="card border-radius-3 border-danger">
                                    <div class="center">
                                        <h4 class="header2">Não Efetivado</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal-duplicar-lead
            :formDataDuplicarLead="formDataDuplicarLead"
            :modalDuplicarLead="modalDuplicarLead"
            @close="modalDuplicarLead = false"
        />
    </div>
</template>
<style>
.border-danger {
  border: 1px solid #ff0000 !important;
  color: #ff0000 !important;
}
.border-success {
  border: 1px solid #90ce47 !important;
  color: #90ce47 !important;
}

.border-negociacao {
  border: 1px solid #5090f8 !important;
  color: #5090f8 !important;
}

.border-analise-seguradora {
  border: 1px solid #f73c4f !important;
  color: #f73c4f !important;
}

.border-danger h4 {
  color: #ff0000 !important;
}
.border-success h4 {
  color: #90ce47 !important;
}
.border-negociacao h4 {
  color: #5090f8 !important;
}
.border-analise-seguradora h4 {
  color: #f73c4f !important;
}

#Tarefas .breadcrumb {
  width: 25% !important;
  text-align: center !important;
}
#Tarefas .breadcrumb:before {
  content: "";
}
#Tarefas .breadcrumb:last-child {
  color: rgba(255, 255, 255, 0.7);
}
.esteira {
  color: rgba(255, 255, 255, 0.6);
}
.esteira .active {
  color: rgba(255, 255, 255, 1) !important;
}
.esteira i {
  position: relative;
  font-size: 50px;
  top: 10px !important;
}
.esteira .estagio.active .background-round {
  background-color: rgba(255, 255, 255, 0.9);
}
.esteira .estagio.active i {
  color: #81c784 !important;
}
.tasks {
  margin: 10px;
  display: inline-block;
}
#Tarefas #card-info i {
  font-size: 40px;
}
#Tarefas #card-info {
  font-size: 12px;
}

#Tarefas .tasks-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px 0 30px 0;
}

#Tarefas .tasks-item .material-icons {
  font-size: 3rem;
}

#Tarefas #card-info .estagio {
  display: none;
}

#Tarefas #card-info .estagio.active {
  display: flex;
}
@media (min-width: 600px) {
  #Tarefas #card-info .estagio {
    display: flex;
  }
}

/* #Tarefas .tasks-item.active{
        background-color: #adadad !important;
    }*/

/* style do card0 */
#Tarefas .card0.tasks-item {
  border: 1px solid #2dbbd2 !important;
}

#Tarefas .card0.tasks-item:not(.active) .material-icons,
#Tarefas .card0.tasks-item:not(.active) p {
  color: #2dbbd2 !important;
}
.card0 .active {
  background-color: #2dbbd2 !important;
  color: #fff;
}

/* style do card1 */
#Tarefas .tasks-item:not(.active) {
  background-color: #fff !important;
  border: 1px solid #ec3d88;
}

#Tarefas .card1.tasks-item:not(.active) .material-icons,
#Tarefas .card1.tasks-item:not(.active) p {
  color: #ec3d88 !important;
}

/* style do card2 */
#Tarefas .card2.tasks-item {
  border: 1px solid #ffd11e;
}

#Tarefas .card2.tasks-item:not(.active) .material-icons,
#Tarefas .card2.tasks-item:not(.active) p {
  color: #ffd11e !important;
}
.card2 .active {
  background-color: #ffd11e !important;
  color: #fff;
}
/* style do em analise */
#Tarefas .cardanalise.tasks-item {
  border: 1px solid #2047a0 !important;
}

#Tarefas .cardanalise.tasks-item:not(.active) .material-icons,
#Tarefas .cardanalise.tasks-item:not(.active) p {
  color: #2047a0 !important;
}
.cardanalise .active {
  background-color: #2047a0 !important;
  color: #fff;
}
/* style do 2ª visita */
#Tarefas .carda2visita.tasks-item {
  border: 1px solid #f59826 !important;
}

#Tarefas .carda2visita.tasks-item:not(.active) .material-icons,
#Tarefas .carda2visita.tasks-item:not(.active) p {
  color: #f59826 !important;
}
.carda2visita .active {
  background-color: #f59826 !important;
  color: #fff;
}
/* style do em analise seguradora */
#Tarefas .cardanaliseguradora.tasks-item {
  border: 1px solid #f73c4f !important;
}

#Tarefas .cardanaliseguradora.tasks-item:not(.active) .material-icons,
#Tarefas .cardanaliseguradora.tasks-item:not(.active) p {
  color: #f73c4f !important;
}
.cardanaliseguradora .active {
  background-color: #f73c4f !important;
  color: #fff;
}
/* style do card3 */
#Tarefas .card3.tasks-item {
  border: 1px solid #5090f7;
}

#Tarefas .card3.tasks-item:not(.active) .material-icons,
#Tarefas .card3.tasks-item:not(.active) p {
  color: #5090f8 !important;
}
.card3 .active {
  background-color: #5090f8 !important;
  color: #fff;
}
/* style do card4 */
#Tarefas .card4.tasks-item {
  border: 1px solid #90ce47;
}
#Tarefas .card4.tasks-item.red {
  border: 1px solid #ff0000;
}

#Tarefas .card4.tasks-item:not(.active) .material-icons,
#Tarefas .card4.tasks-item:not(.active) p {
  color: #90ce47 !important;
}
.card4 .active {
  background-color: #90ce47;
  color: #fff;
}

#Tarefas .tasks-item.active {
  color: #fff !important;
}
</style>
<script>
import DetalhamentoEstadoSelect from "@/components/lead/form/DetalhamentoEstadoSelect";
import TipoSelect from "@/components/lead/form/TipoSelect";
import InputData from "@/components/lead/form/InputData";
import InputHora from "@/components/lead/form/InputHora";
import ResponsavelSelect from "@/components/lead/form/ResponsavelSelect";
import ObservacoesText from "@/components/lead/form/ObservacoesText";
import ModalDuplicarLead from "@/components/lead/ModalDuplicarLead";
import swal from "sweetalert2";
import {
  ESTAGIO_PROSPECCAO,
  ESTAGIO_CHAMADA_TELEFONICA,
  ESTAGIO_PRIMEIRA_VISITA,
  ESTAGIO_EFETIVADO,
  ESTAGIO_NEGATIVADO,
  ESTAGIO_SEGUNDA_VISITA,
  ESTAGIO_EM_ESPERA,
  ESTAGIO_PERDIDO,
  ESTAGIO_NEGOCIACAO,
} from "@/constants/pedidoEstagio.js";
import { api, get, post } from "@/helpers/api";
import Message from "@/helpers/message";
import MaskedInput from "vue-masked-input";
import {
  DONO,
  GERENTE,
  CORRETOR,
  ESPECIALISTA,
  LIDER,
  MASTER,
} from "@/constants/funcionarioCargo.js";
import Auth from "@/store/auth";
import CardInfo from "@/components/lead/CardInfo";
import moment from "moment";
import GmapInput from "../common/GmapInput.vue";

export default {
  components: {
    DetalhamentoEstadoSelect,
    TipoSelect,
    InputData,
    InputHora,
    ResponsavelSelect,
    ObservacoesText,
    MaskedInput,
    CardInfo,
    GmapInput,
    ModalDuplicarLead,
  },
  props: ["pedido"],
  data: () => ({
    dataTarefa: "",
    horaTarefa: "",
    tipoTarefa: "",
    detalhamentoTarefa: "",
    responsavelTarefa: "",
    observacoesTarefa: "",
    successEfetivado: false,
    successNegativado: false,
    hideActions: false,
    funcionarios: [],
    classeFinalizarEfetivado: "border-success",
    classeFinalizarNaoEfetivado: "border-danger",
    estadoContatoTelefonico: [
      { id: 1, mensagem: "Efetuado e agendado" },
      { id: 2, mensagem: "Não atendeu" },
      { id: 3, mensagem: "Telefone ocupado" },
      { id: 4, mensagem: "Telefone não existe" },
      { id: 5, mensagem: "Telefone desligado" },
      { id: 6, mensagem: "Efetuado com retorno" },
      { id: 7, mensagem: "Não possui mais interesse" },
    ],
    estadoContatoEmail: [
      { id: 1, mensagem: "Efetuado e agendado" },
      { id: 6, mensagem: "Efetuado com retorno" },
      { id: 7, mensagem: "Não possui mais interesse" },
    ],
    pedido_contato: {
      pedido_contato_tipo: "",
      pedido_contato_estado_id: "",
      pedido_contato_data: "",
      pedido_contato_hora: "",
      pedido_contato_observacoes: "",
    },
    pedido_contato_avulso: {
      funcionario_id: "",
      pedido_contato_avulso_tipo: "",
      pedido_contato_avulso_estado_id: "",
      pedido_contato_avulso_data: moment().format("DD/MM/YYYY"),
      pedido_contato_avulso_hora: moment().format("HH:mm"),
      pedido_contato_avulso_observacoes: "",
    },
    pedido_visita: {
      pedido_visita_tipo: "",
      pedido_visita_estado_id: "",
      pedido_visita_data: moment().format("DD/MM/YYYY"),
      pedido_visita_hora: moment().format("HH:mm"),
      pedido_visita_observacoes: "",
      pedido_historico_agenda_endereco: "",
      pedido_historico_agenda_endereco_latitude: "",
      pedido_historico_agenda_endereco_longitude: "",
    },
    pedido_visita_avulsa: {
      pedido_visita_tipo: "",
      pedido_visita_estado_id: "",
      pedido_visita_data: moment().format("DD/MM/YYYY"),
      pedido_visita_hora: moment().format("HH:mm"),
      pedido_visita_observacoes: "",
    },
    pedido_efetivado: {
      pedido_efetivado_motivo: "",
      pedido_efetivado_observacoes: "",
    },
    pedido_negativado: {
      pedido_negativado_motivo: "",
      pedido_negativado_observacoes: "",
    },
    usuarioLogadoCargo: null,
    cargoDono: null,
    cargoGerente: null,
    cargoCorretor: null,
    cargoEspecialista: null,
    cargoLider: null,
    showFormEfetivado: false,
    showFormNegativado: false,
    showContainerVisita: 1,
    showContainerNegociacao: 1,
    modalDuplicarLead: false,
    formDataDuplicarLead: {
      empresa_indicada_id: 1,
      cliente_id: null,
      produto_id: null,
      pedido_estagio_id: 1,
      plataforma_origem: 1,
    },
  }),
  mounted() {
    $(this.$refs.tabVisita).tabs();
    $(this.$refs.tabNegociacao).tabs();

    this.pedido_contato.pedido_contato_data = moment().format("DD/MM/YYYY");
    this.pedido_contato.pedido_contato_hora = moment().format("HH:mm");
    this.pedido_contato_avulso.pedido_contato_avulso_data =
      moment().format("DD/MM/YYYY");
    this.pedido_contato_avulso.pedido_contato_avulso_hora =
      moment().format("HH:mm");

    this.pedido_visita.pedido_visita_data = moment().format("DD/MM/YYYY");
    this.pedido_visita.pedido_visita_hora = moment().format("HH:mm");
  },
  methods: {
    classEfetivado() {
      let classes = "";
      if (this.mostrarFinalizar() || this.checkColdMark([4, 5, 8])) {
        classes = "active ";
      }
      if (
        (!this.checkActions() && this.checarBotaoNegativar()) ||
        this.successNegativado
      ) {
        classes += "red";
      } else {
        classes += "light-green";
      }
      return classes;
    },
    getData(data) {
      return moment(data, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm");
    },
    checkShowFormEfetivado() {
      return this.showFormEfetivado;
    },
    checkShowFormNegativado() {
      return this.showFormNegativado;
    },
    salvarConcluirNegociacao() {
      let self = this;
      post("processo/negociacao-concluida", {
        pedido_historico_id: this.pedido.pedido_historico_id,
      })
        .then(function (response) {
          self.$emit("atualiza", [response.data.result.data]);

          self.pedido_visita_avulsa = {
            pedido_visita_tipo: "",
            pedido_visita_estado_id: "",
            pedido_visita_data: "",
            pedido_visita_hora: "",
            pedido_visita_observacoes: "",
          };

          Message.messageSuccess(response.data.statusMessage);
        })
        .catch(function () {
          Message.messageError("Ocorreu um erro ao salvar, tente novamente.");
        });
    },
    salvarVisitaAvulsa() {
      if (
        this.pedido_visita_avulsa.pedido_visita_tipo === "" ||
        this.pedido_visita_avulsa.pedido_visita_estado_id === "" ||
        this.pedido_visita_avulsa.pedido_visita_data === "" ||
        this.pedido_visita_avulsa.pedido_visita_hora === ""
      ) {
        Message.messageError("Todos os campos são necessários.");
        return;
      }

      let self = this;
      post("processo/visita-avulsa", {
        pedido_id: this.pedido.pedido_id,
        pedido_visita_avulsa_tipo: this.pedido_visita_avulsa.pedido_visita_tipo,
        pedido_visita_avulsa_estado_id:
          this.pedido_visita_avulsa.pedido_visita_estado_id,
        pedido_visita_avulsa_data: this.pedido_visita_avulsa.pedido_visita_data,
        pedido_visita_avulsa_hora: this.pedido_visita_avulsa.pedido_visita_hora,
        pedido_visita_avulsa_observacoes:
          this.pedido_visita_avulsa.pedido_visita_observacoes,
      })
        .then(function (response) {
          self.$emit("atualiza", [response.data.result.data]);

          self.pedido_visita_avulsa = {
            pedido_visita_tipo: "",
            pedido_visita_estado_id: "",
            pedido_visita_data: "",
            pedido_visita_hora: "",
            pedido_visita_observacoes: "",
          };

          Message.messageSuccess(response.data.statusMessage);
        })
        .catch(function () {
          Message.messageError("Ocorreu um erro ao salvar, tente novamente.");
        });
    },
    pularEmNegociacao() {
      let self = this;
      swal({
        title:
          "Tem certeza de que quer avançar para o estágio de Em Negociação?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-segunda-visita-negociacao", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal("Estágio avançado com sucesso.", "", "success");

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    pularAnaliseSeguradora() {
      let self = this;
      swal({
        title:
          "Tem certeza de que quer avançar para o estágio de Análise da Seguradora?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-segunda-visita-analise-seguradora", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal("Estágio avançado com sucesso.", "", "success");

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    pularNegociacaoParaAnaliseSeguradora() {
      let self = this;
      swal({
        title:
          "Tem certeza de que quer avançar para o estágio de Análise da Seguradora?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-negociacao-analise-seguradora", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal("Estágio avançado com sucesso.", "", "success");

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    salvarVisita() {
      if (
        this.pedido_visita.pedido_visita_tipo === "" ||
        this.pedido_visita.pedido_visita_estado_id === "" ||
        this.pedido_visita.pedido_visita_data === "" ||
        this.pedido_visita.pedido_visita_hora === ""
      ) {
        Message.messageError(
          "Todos os campos são necessários.",
          3000,
          "red rounded"
        );
        return;
      }

      let self = this;
      post("processo/visita", {
        pedido_id: this.pedido.pedido_id,
        pedido_visita_tipo: this.pedido_visita.pedido_visita_tipo,
        pedido_visita_estado_id: this.pedido_visita.pedido_visita_estado_id,
        pedido_visita_data: this.pedido_visita.pedido_visita_data,
        pedido_visita_hora: this.pedido_visita.pedido_visita_hora,
        pedido_visita_observacoes: this.pedido_visita.pedido_visita_observacoes,
        pedido_historico_agenda_endereco:
          this.pedido_visita.pedido_historico_agenda_endereco,
        pedido_historico_agenda_endereco_latitude:
          this.pedido_visita.pedido_historico_agenda_endereco_latitude,
        pedido_historico_agenda_endereco_longitude:
          this.pedido_visita.pedido_historico_agenda_endereco_longitude,
      })
        .then(function (response) {
          self.$emit("atualiza", [response.data.result.data]);

          self.pedido_visita = {
            pedido_visita_tipo: "",
            pedido_visita_estado_id: "",
            pedido_visita_data: "",
            pedido_visita_hora: "",
            pedido_visita_observacoes: "",
            pedido_historico_agenda_endereco: "",
            pedido_historico_agenda_endereco_latitude: "",
            pedido_historico_agenda_endereco_longitude: "",
          };
          //self.pedido = response.data.result.data;
          Message.messageSuccess(
            response.data.statusMessage,
            3000,
            "green rounded"
          );
        })
        .catch(function () {
          Message.messageError(
            "Ocorreu um erro ao salvar, tente novamente.",
            3000,
            "red rounded"
          );
        });
    },
    salvarContatoAvulso() {
      if (
        this.pedido_contato_avulso.pedido_contato_avulso_tipo === "" ||
        this.pedido_contato_avulso.pedido_contato_avulso_estado_id === "" ||
        this.pedido_contato_avulso.pedido_contato_avulso_data === "" ||
        this.pedido_contato_avulso.pedido_contato_avulso_hora === ""
      ) {
        Message.messageError(
          "Todos os campos são necessários.",
          3000,
          "red rounded"
        );
        return;
      }

      let self = this;
      post("processo/contato-avulso", {
        pedido_id: this.pedido.pedido_id,
        pedido_contato_avulso_tipo:
          this.pedido_contato_avulso.pedido_contato_avulso_tipo,
        pedido_contato_avulso_estado_id:
          this.pedido_contato_avulso.pedido_contato_avulso_estado_id,
        pedido_contato_avulso_data:
          this.pedido_contato_avulso.pedido_contato_avulso_data,
        pedido_contato_avulso_hora:
          this.pedido_contato_avulso.pedido_contato_avulso_hora,
        pedido_contato_avulso_observacoes:
          this.pedido_contato_avulso.pedido_contato_avulso_observacoes,
        funcionario_id: this.pedido_contato_avulso.funcionario_id,
      })
        .then(function (response) {
          self.$emit("atualiza", [response.data.result.data]);

          self.pedido_contato_avulso = {
            pedido_contato_avulso_tipo: "",
            pedido_contato_avulso_estado_id: "",
            pedido_contato_avulso_data: "",
            pedido_contato_avulso_hora: "",
            pedido_contato_avulso_observacoes: "",
          };
          //self.pedido = response.data.result.data;
          Message.messageSuccess(
            response.data.statusMessage,
            3000,
            "green rounded"
          );
        })
        .catch(function () {
          Message.messageError(
            "Ocorreu um erro ao salvar, tente novamente.",
            3000,
            "red rounded"
          );
        });
    },
    salvarContatoAvulsoNegociacao() {
      if (
        this.pedido_contato_avulso.pedido_contato_avulso_tipo === "" ||
        this.pedido_contato_avulso.pedido_contato_avulso_estado_id === "" ||
        this.pedido_contato_avulso.pedido_contato_avulso_data === "" ||
        this.pedido_contato_avulso.pedido_contato_avulso_hora === ""
      ) {
        Message.messageError(
          "Todos os campos são necessários.",
          3000,
          "red rounded"
        );
        return;
      }

      let self = this;
      post("processo/contato-avulso-negociacao", {
        pedido_id: this.pedido.pedido_id,
        pedido_contato_avulso_tipo:
          this.pedido_contato_avulso.pedido_contato_avulso_tipo,
        pedido_contato_avulso_estado_id:
          this.pedido_contato_avulso.pedido_contato_avulso_estado_id,
        pedido_contato_avulso_data:
          this.pedido_contato_avulso.pedido_contato_avulso_data,
        pedido_contato_avulso_hora:
          this.pedido_contato_avulso.pedido_contato_avulso_hora,
        pedido_contato_avulso_observacoes:
          this.pedido_contato_avulso.pedido_contato_avulso_observacoes,
        funcionario_id: this.pedido_contato_avulso.funcionario_id,
      })
        .then(function (response) {
          self.$emit("atualiza", [response.data.result.data]);

          self.pedido_contato_avulso = {
            pedido_contato_avulso_tipo: "",
            pedido_contato_avulso_estado_id: "",
            pedido_contato_avulso_data: "",
            pedido_contato_avulso_hora: "",
            pedido_contato_avulso_observacoes: "",
          };
          Message.messageSuccess(
            response.data.statusMessage,
            3000,
            "green rounded"
          );
        })
        .catch(function () {
          Message.messageError(
            "Ocorreu um erro ao salvar, tente novamente.",
            3000,
            "red rounded"
          );
        });
    },
    salvar() {
      if (
        this.pedido_contato.pedido_contato_tipo === "" ||
        this.pedido_contato.pedido_contato_estado_id === "" ||
        this.pedido_contato.pedido_contato_data === "" ||
        this.pedido_contato.pedido_contato_hora === ""
      ) {
        Message.messageError(
          "Todos os campos são necessários.",
          3000,
          "red rounded"
        );
        return;
      }

      let self = this;
      post("processo/contato", {
        pedido_id: this.pedido.pedido_id,
        pedido_contato_tipo: this.pedido_contato.pedido_contato_tipo,
        pedido_contato_estado: this.pedido_contato.pedido_contato_estado_id,
        pedido_contato_data: this.pedido_contato.pedido_contato_data,
        pedido_contato_hora: this.pedido_contato.pedido_contato_hora,
        pedido_contato_observacoes:
          this.pedido_contato.pedido_contato_observacoes,
      })
        .then(function (response) {
          self.$emit("atualiza", [response.data.result.data]);

          let pedidoEstagioConcluido =
            self.pedido_contato.pedido_contato_estado_id;

          self.pedido_contato = {
            pedido_contato_tipo: "",
            pedido_contato_estado_id: "",
            pedido_contato_data: "",
            pedido_contato_hora: "",
            pedido_contato_observacoes: "",
          };
          //self.pedido = response.data.result.data;
          Message.messageSuccess(
            response.data.statusMessage,
            3000,
            "green rounded"
          );
        })
        .catch(function () {
          Message.messageError(
            "Ocorreu um erro ao salvar, tente novamente.",
            3000,
            "red rounded"
          );
        });
    },
    mostrarAnaliseSeguradora() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_NEGATIVADO
      );
    },
    mostrarNegociacao() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_NEGOCIACAO
      );
    },
    mostrarFinalizar() {
      if (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_PERDIDO &&
        this.pedido.pedido_historico.pedido_negociacao_concluida === 1
      ) {
        return true;
      }

      let array = [ESTAGIO_EFETIVADO, ESTAGIO_PERDIDO];
      return (
        array.indexOf(this.pedido.pedido_historico.pedido_estagio_id) !== -1
      );
    },
    mostrarProspeccao() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_PROSPECCAO
      );
    },
    mostrarContato() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id ===
        ESTAGIO_CHAMADA_TELEFONICA
      );
    },
    mostrarVisita() {
      // if (this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_PRIMEIRA_VISITA &&
      //     this.pedido.pedido_historico.pedido_visita_estado_id === 2
      // ) {
      //     return false;
      // }

      // if (this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_CHAMADA_TELEFONICA &&
      //     this.pedido.pedido_historico.pedido_contato_estado_id === 1) {
      //     return true;
      // }
      return (
        this.pedido.pedido_historico.pedido_estagio_id ===
        ESTAGIO_PRIMEIRA_VISITA
      );
    },
    mostrarAnaliseNecessidade() {
      return (
        this.pedido.pedido_historico_id.pedido_historico_id ===
        ESTAGIO_EM_ESPERA
      );
    },
    mostrarSegundaVisita() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id ===
        ESTAGIO_SEGUNDA_VISITA
      );
    },
    mostrarCold() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_EM_ESPERA
      );
    },
    mostrarNegativado() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_NEGATIVADO
      );
    },
    mostrarLost() {
      return this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_PERDIDO;
    },
    efetivar() {
      if (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_EFETIVADO
      ) {
        Message.messageError("Pedido já efetivado.", 3000, "red rounded");
        return;
      }
      this.classeFinalizarEfetivado = "green-light";
      this.classeFinalizarNaoEfetivado = "border-danger";
      this.showFormEfetivado = true;
      this.showFormNegativado = false;
    },
    negativar() {
      if (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_EFETIVADO
      ) {
        Message.messageError("Pedido já negativado.", 3000, "red rounded");
        return;
      }
      this.classeFinalizarEfetivado = "border-success";
      this.classeFinalizarNaoEfetivado = "red";
      this.showFormEfetivado = false;
      this.showFormNegativado = true;
    },
    salvarNegativado() {
      if (
        this.pedido_negativado.pedido_negativado_motivo === "" ||
        this.pedido_negativado.pedido_negativado_observacoes === ""
      ) {
        Message.messageError(
          "Todos os campos são obrigatórios.",
          3000,
          "red rounded"
        );
        return;
      }

      let self = this;
      post("processo/lost", {
        pedido_id: this.pedido.pedido_id,
        pedido_lost_motivo:
          this.pedido_negativado.pedido_negativado_motivo,
        pedido_nao_efetivado_observacao:
          this.pedido_negativado.pedido_negativado_observacoes,
      })
        .then(function (response) {
          self.showFormEfetivado = false;
          self.showFormNegativado = false;
          self.successNegativado = true;
          self.hideActions = true;

          self.$emit("atualiza", [response.data.result.data]);
          Message.messageSuccess(
            response.data.statusMessage,
            3000,
            "green rounded"
          );
        })
        .catch(function () {
          Message.messageError(
            "Ocorreu um erro ao salvar, tente novamente.",
            3000,
            "red rounded"
          );
        });
    },
    salvarEfetivado() {
      let self = this;

      post("processo/efetivar", {
        pedido_id: this.pedido.pedido_id,
        pedido_efetivado_observacao:
          this.pedido_efetivado.pedido_efetivado_observacoes,
      })
        .then(function (response) {
          self.$emit("atualiza", [response.data.result.data]);

          self.showFormEfetivado = false;
          self.showFormNegativado = false;
          self.successEfetivado = true;
          self.hideActions = true;

          $("#card-actions .darken-4").removeClass("darken-4");
          $("#card-actions button").addClass("disabled");
          //self.pedido = response.data.result.data;
          Message.messageSuccess(
            response.data.statusMessage,
            3000,
            "green rounded"
          );
        })
        .catch(function () {
          Message.messageError(
            "Ocorreu um erro ao salvar, tente novamente.",
            3000,
            "red rounded"
          );
        });
    },
    checkActions() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id !== ESTAGIO_PERDIDO &&
        this.pedido.pedido_historico.pedido_estagio_id !== ESTAGIO_EFETIVADO
      );
    },
    checarBotaoEfetivar() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_EFETIVADO
      );
    },
    checarBotaoNegativar() {
      return (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_PERDIDO
      );
    },
    checaCargoUsuario(arrayPode) {
      if (this.usuarioLogadoCargo === MASTER) {
        return true;
      }
      return arrayPode.indexOf(this.usuarioLogadoCargo) !== -1;
    },
    checarVisualizacao() {
      return typeof this.pedido.pedido_historicos !== "undefined";
    },
    checarCurrent(arrayId) {
      if (typeof this.pedido.pedido_historico === "undefined") {
        return false;
      }
      return (
        arrayId.indexOf(this.pedido.pedido_historico.pedido_estagio_id) !== -1
      );
    },
    checkColdMark(arrayCheck) {
      if (
        this.pedido.pedido_historico.pedido_estagio_id === ESTAGIO_EM_ESPERA
      ) {
        let lastPedido = {};
        this.pedido.pedido_historicos.forEach(function (obj) {
          if (
            obj.pedido_historico_id !== this.pedido.pedido_historico_id &&
            obj.pedido_estagio_id !== ESTAGIO_EM_ESPERA
          ) {
            if (typeof lastPedido.pedido_historico_id === "undefined") {
              lastPedido = obj;
            } else {
              if (obj.pedido_historico_id > lastPedido.pedido_historico_id) {
                lastPedido = obj;
              }
            }
          }
        }, this);

        if (arrayCheck.indexOf(lastPedido.pedido_estagio_id) !== -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    retirarDeEspera(pedido) {
      let self = this;
      swal({
        title: "Tem certeza que quer retirar da espera?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("pedido/voltar-ultimo-historico", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal("Retirado com sucesso.", "", "success");

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    checkValue(value) {
      if (value !== "") {
        return "active";
      }
      return "";
    },
    pularProspeccao() {
      let self = this;
      swal({
        title: "Tem certeza de que quer avançar para o próximo estágio?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-prospeccao", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal("Estágio avançado com sucesso.", "", "success");

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    pularContato() {
      let self = this;
      swal({
        title: "Tem certeza de que quer avançar para o próximo estágio?",
        // title: 'Tem certeza que deseja pular essa etapa?',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-contato", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal(
              "Estágio avançado com sucesso.",
              // 'Etapa pulada com sucesso.',
              "",
              "success"
            );

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    pularVisita() {
      let self = this;
      swal({
        title: "Tem certeza de que quer avançar para o próximo estágio?",
        // title: 'Tem certeza que deseja pular essa etapa?',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-primeira-visita", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal(
              "Estágio avançado com sucesso.",
              // 'Etapa pulada com sucesso.',
              "",
              "success"
            );

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    pularAnaliseNecessidade() {
      let self = this;
      swal({
        title: "Tem certeza de que quer avançar para o próximo estágio?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-analise-necessidades", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal("Estágio avançado com sucesso.", "", "success");

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    pularSegundaVisita() {
      let self = this;
      swal({
        title: "Tem certeza de que quer avançar para o próximo estágio?",
        // title: 'Tem certeza que deseja pular essa etapa?',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          post("processo/pular-segunda-visita", {
            pedido_id: self.pedido.pedido_id,
          }).then(function (response) {
            swal(
              "Estágio avançado com sucesso.",
              // 'Etapa pulada com sucesso.',
              "",
              "success"
            );

            self.$emit("atualiza", [response.data.result.data]);
          });
        }
      });
    },
    handleDataGmapVisita(e) {
      [
        this.pedido_visita.pedido_historico_agenda_endereco,
        this.pedido_visita.pedido_historico_agenda_endereco_latitude,
        this.pedido_visita.pedido_historico_agenda_endereco_longitude,
      ] = e;
    },
    getContatoStatus(id) {
      switch (id) {
        case 1:
          return "Efetuado e agendado";
        case 2:
          return "Não atendeu";
        case 3:
          return "Telefone ocupado";
        case 4:
          return "Telefone não existe";
        case 5:
          return "Telefone desligado";
        case 6:
          return "Efetuado com retorno";
        case 7:
          return "Não possui mais interesse";
      }
    },
    getVisitaStatus(id) {
      switch (id) {
        case 1:
          return "Marcação";
        case 2:
          return "Efetuada com sucesso";
        case 3:
          return "Remarcada";
        case 4:
          return "Não estava presente";
        case 5:
          return "Cancelada";
      }
    },
    duplicarLead() {
      this.formDataDuplicarLead = {
        empresa_indicada_id: 1,
        cliente_id: this.pedido.cliente_has_produto.cliente_id,
        produto_id: null,
        pedido_estagio_id: 1,
        plataforma_origem: 1,
      };

      this.modalDuplicarLead = true;
    },
  },
  updated() {
    // console.log('up', this);
    if (this.successNegativado || this.successEfetivado) {
      $(".finalizarActions").hide();
    }
  },
  created() {
    // console.log('tarefa', this.pedido);
    this.usuarioLogadoCargo = Auth.getCargoUsuario();
    this.cargoDono = DONO;
    this.cargoGerente = GERENTE;
    this.cargoCorretor = CORRETOR;
    this.cargoEspecialista = ESPECIALISTA;
    this.cargoLider = LIDER;

    this.dataAgora = moment().format("DD/MM/YYYY");
    this.horaAgora = moment().format("HH:mm");

    let self = this;

    if (Auth.state.user.pessoa.funcionario.funcionario_cargo_id !== 3) {
      get("funcionario").then(function (response) {
        self.funcionarios = response.data.result.data;
      });
    }

    $("#pedido_contato_data").removeAttr("disabled");

    if (
      (!this.checkActions() && this.checarBotaoEfetivar()) ||
      this.successEfetivado ||
      (!this.checkActions() && this.checarBotaoNegativar()) ||
      this.successNegativado
    ) {
      $("#card-actions .darken-4").removeClass("darken-4");
      $("#card-actions button").addClass("disabled");
    }
  },
};
</script>
<style scoped>
.center,
.center-align {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/lead/Tarefas.vue